<template>
  <div>
    <div class="container flex flex-wrap justify-center pt-8">
      <div class="w-4/5 md:w-3/5">
        <div class="py-6">
          <h1 class="page-title">{{ page.title }}</h1>
          <div class="page-content" v-html="page.tekst"/>
        </div>
      </div>
      <div>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div v-for="item in news" :key="item.permalink">
            <button-gradient-border :link="`/nieuws/${item.permalink}`" class="h-full">
              <template v-slot:content>
                <img :src="item.image" :alt="item.title" class="object-cover" style="height: 150px; width: 100%;">
                <div class="inline-block pt-5">
                  <div class="flex flex-col">
                    <div>{{ item.title }}</div>
                    <div class="text-primary-lighter font-light leading-8">
                      <time :datetime="item.date">{{ $moment(item.date).format('LL') }}</time>
                    </div>
                    <div class="text-sm font-body font-light py-3 md:pr-3" v-html="item.short_text"/>
                  </div>
                </div>
              </template>
            </button-gradient-border>
          </div>
        </div>
        <div class="flex justify-end py-6">
          <button v-if="nextPage" class="focus:outline-none text-secondary" @click="next">Bekijk meer berichten</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page from '~/plugins/mixins/page';
import ButtonGradientBorder from '~/components/ButtonGradientBorder';

export default {
  components: {
    ButtonGradientBorder,
  },
  mixins: [page],
  data: () => ({
    nextPage: null,
    news: [],
  }),
  created() {
    this.getNews();
  },
  methods: {
    next() {
      this.getNews(this.nextPage);
    },
    async getNews(page = null) {
      try {
        const {data} = await this.$axios.get(`/news?page=${page}`);

        if (data.meta.current_page < data.meta.last_page) {
          this.nextPage = data.meta.current_page + 1;
        } else {
          this.nextPage = null;
        }

        this.news.push.apply(this.news, data.data);
      } catch (e) {
        this.error({statusCode: 404, message: e.message});
      }
    },
  },
};
</script>
